import { jsx as _jsx } from "react/jsx-runtime";
import { cx } from '../../utils/cx';
import styles from './typography.module.css';
const LINES_CLASS = {
    2: styles.lines2,
    3: styles.lines3,
};
const RESERVE_CLASS = {
    1: styles.reserve1,
    2: styles.reserve2,
    3: styles.reserve3,
};
function cutClasses(truncate, lines, reserve) {
    if (truncate)
        return [styles.truncate, reserve ? RESERVE_CLASS[1] : undefined];
    if (lines !== undefined)
        return [styles.clamp, LINES_CLASS[lines], reserve ? RESERVE_CLASS[lines] : undefined];
    return [];
}
/** Internal core renderer. Do not export from the barrel. */
export function TypographyText({ as: As, roleClassName, color, extraStyle, style, truncate = false, lines, reserve = false, children, className, id, role, ...rest }) {
    const hasInlineStyle = color !== undefined || extraStyle !== undefined || style !== undefined;
    const mergedStyle = hasInlineStyle
        ? {
            ...(color !== undefined ? { color } : undefined),
            ...extraStyle,
            ...style,
        }
        : undefined;
    return (_jsx(As, { className: cx(roleClassName, ...cutClasses(truncate, lines, reserve), className), id: id, role: role, style: mergedStyle, ...rest, children: children }));
}
//# sourceMappingURL=_core.js.map